import Field from "./Field";

const YouSection = ({ form, onChange }) => (
    <section className="space-y-6">
        <h2 className="font-serif text-2xl font-medium tracking-tight">You</h2>
        <div className="grid gap-6 md:grid-cols-2">
            <Field
                id="name"
                label="Full name"
                value={form.name}
                onChange={(v) => onChange("name", v)}
                testId="field-name"
                placeholder="Maggie Sullivan"
                required
            />
            <Field
                id="email"
                label="Email"
                type="email"
                value={form.email}
                onChange={(v) => onChange("email", v)}
                testId="field-email"
                placeholder="you@email.com"
                required
            />
        </div>
        <Field
            id="current_title"
            label="Current title & company"
            value={form.current_title}
            onChange={(v) => onChange("current_title", v)}
            testId="field-current-title"
            placeholder="Senior Director, Commercial Banking — Regional Bank"
            required
        />
    </section>
);

export default YouSection;
